module.exports = __webpack_public_path__ + "static/media/react-native-icon.8b24e06c.png";